import { useConfig } from '@occc/config';

import RetailerNetworkLocationDetailsPage from './retailer-network-location-details-page';
import RetailerNetworkMyStoresStoreV2Page from './retailer-network-my-stores-store-v2-page';

export const RetailerNetworkLocationDetailsVersionSwitch = () => {
  const { config } = useConfig();

  return config.retailerConnectRedesignV2.enabled ? (
    <RetailerNetworkMyStoresStoreV2Page />
  ) : (
    <RetailerNetworkLocationDetailsPage />
  );
};
